import {handleResponse, authHeader} from '../helpers';
const BASE_URL = process.env.REACT_APP_API_URL;

export const duplicatesService = {
	getDuplicates,
	getWebsocketTicket
}

function getWebsocketTicket() {
	const requestOptions = {
		method: 'POST',
		headers: authHeader(),
	};

	return fetch(BASE_URL + '/ws-ticket', requestOptions)
		.then(handleResponse);
}

function getDuplicates() {
	const requestOptions = {
		method: 'GET',
		headers: authHeader(),
	};

	return fetch(BASE_URL + '/duplicates', requestOptions)
		.then(handleResponse)
		.then(response => {
			return response;
		});
}
